import { Button } from 'components/ui';
import { AuthSignInFooterPrompt, AuthSuccessPanel } from 'pages/Auth/components';
import {
  SIGN_UP_CONFIRMATION_DESCRIPTION,
  SIGN_UP_CONFIRMATION_TITLE,
} from 'pages/Auth/SignUp/SignUp.constants';
import { SignUpConfirmationStepProps } from './SignUpConfirmationStep.props';

const SignUpConfirmationStep = ({
  isResendDisabled,
  isResending,
  onResendActivation,
  resendActionLabel,
  signInHref,
}: SignUpConfirmationStepProps) => (
  <AuthSuccessPanel
    description={SIGN_UP_CONFIRMATION_DESCRIPTION}
    extraAction={
      <AuthSignInFooterPrompt replace to={signInHref} />
    }
    mainAction={
      <Button
        disabled={isResendDisabled}
        loading={isResending}
        loadingBehavior="inline"
        onClick={onResendActivation}
        type="button"
        variant="outlined"
        visualVariant="primaryOutline"
      >
        {resendActionLabel}
      </Button>
    }
    title={SIGN_UP_CONFIRMATION_TITLE}
  />
);

export default SignUpConfirmationStep;
